import { GET_WALLET, LOAD_DONE, LOAD_REQUEST } from '../types';

const initialState = {
  WALLET_LIST: [],
  isLoading: false
};

export const WalletReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAD_REQUEST: {
      return { ...state, isLoading: true };
    }
    case GET_WALLET: {
      return { ...state, WALLET_LIST: payload, isLoading: false };
    }
    case LOAD_DONE: {
      return { ...state, isLoading: false };
    }
    default:
      return state;
  }
};
